import apiV1 from '@/services/authorization/api.service';

const crudApi = (path) => ({
  index(params) {
    return apiV1.get(path, params);
  },
  show(id, params) {
    return apiV1.get(`${path}/${id}`, params);
  },
  create(data) {
    return apiV1.post(`${path}/new`, data);
  },
  update(id, data) {
    return apiV1.patch(`${path}/${id}/edit`, data);
  },
  delete(id) {
    return apiV1.delete(`${path}/${id}`);
  },
});

const entityApi = {
  get product() {
    return crudApi('/product/product');
  },
  get scope() {
    return crudApi('/oauth/scope');
  },
  get user() {
    return {
      ...crudApi('/user'),
      findOrCreateYandexUser(params) {
        return apiV1.post('/user/find-or-create-yandex-user', params);
      },
    };
  },
  get category() {
    return crudApi('/product/category');
  },
  get location() {
    return crudApi('/location/location');
  },
  get productTransfer() {
    return {
      index(params) {
        return apiV1.get('/product/transfer', params);
      },
      show(id, params) {
        return apiV1.get(`/product/transfer/${id}`, params);
      },
      make(data) {
        return apiV1.post('/product/transfer/make', data);
      },
      transfer(data) {
        return apiV1.post('/product/transfer', data);
      },
    };
  },
};

export default entityApi;
